export default __webpack_public_path__ + "images/e59795854cc6700f11543160e54ed8f6.png";